import script from "./TourOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./TourOverlay.vue?vue&type=script&setup=true&lang=js"

import "./TourOverlay.vue?vue&type=style&index=0&id=2168538e&lang=css"

const __exports__ = script;

export default __exports__